import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';
import { DafService } from 'src/app/DAF/services/dafService';
import { EympService } from 'src/app/eymp-reverseflow/services/eympservice';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  dateFilterModel: DateFilterModel;
  fromReportDate: any;
  toReportDate: any;
  public isPageReady = false;
  public caseList: any[];

  caseRevflowSuccess: number;
  caseRevflowFailure: number;
  caseRevflowReady: number;
  constructor(private router: Router, private commonService: CommonService, public _dafService: DafService, public _eympservice: EympService) {
    this.dateFilterModel = new DateFilterModel(new Date(2020, 1, 1), new Date())
  }

  ngOnInit(): void {
    this._dafService.currentInsDates.subscribe(data => {
      if (data && data.fromDate && data.toDate) {
        this.fromReportDate = data.fromDate;
        this.toReportDate = data.toDate;
        this.dateFilterModel = new DateFilterModel(new Date(this.fromReportDate), new Date(this.toReportDate));
        this.getCaseDetails();
      } else {
        this.getCaseDraftReportDate();
      }
    });
    this.isPageReady = true;
  }

  getCaseDraftReportDate() {

    this.commonService.getINSZoomReportDate()
      .subscribe((data: any) => {
        this._dafService.updateINSDate({ fromDate: data.reportDate, toDate: data.reportDate });
        this.getCaseDetails();
      });
  }
  getCaseDetails() {

    this._dafService.currentInsDates
      .subscribe((data: any) => {
        this.fromReportDate = data.fromDate;
        this.toReportDate = data.toDate;
        this.dateFilterModel = new DateFilterModel(new Date(this.fromReportDate), new Date(this.toReportDate));
        this._eympservice.getDashboardCount(this.dateFilterModel.startDate.toDateString(), this.dateFilterModel.endDate.toDateString()).subscribe((data: any) => {
          // Binds the data to grid
          this.caseList = data;


          this.caseRevflowReady = data.caseRevflowCreated;
          this.caseRevflowSuccess = data.caseRevflowSuccess;
          this.caseRevflowFailure = data.caseRevflowFailure;

          this.isPageReady = true;
          console.log(this.caseList);
        },
          (error) => {
            this.isPageReady = true;
            // this.notifier.notify('error', 'Error occured while getting data from server');
          }
        );

      },
        (error) => {
          //this.notifier.notify('error', 'Error occured while updating the user details');
        }
      );

  }
  filterCaseList() {
    this._dafService.updateINSDate({ fromDate: this.dateFilterModel.startDate.toDateString(), toDate: this.dateFilterModel.endDate.toDateString() });
  }
  getCaseRevflowReady() {
    this.router.navigate(['/reverseflowdetails'], { queryParams: { 'Status': 'Ready for Reverse flow Upload', 'RevflowStatus': 'Reverseflow' } });
  }
  getCaseRevflowSuccess() {
    this.router.navigate(['/reverseflowdetails'], { queryParams: { 'Status': 'Success', 'RevflowStatus': 'Reverseflow' } });
  }
  getCaseRevflowFailure() {
    this.router.navigate(['/reverseflowdetails'], { queryParams: { 'Status': 'Failure', 'RevflowStatus': 'Reverseflow' } });
  }
  resetDashboard() {
    this._dafService.resetDate.subscribe(data => {
      this._dafService.updateINSDate({ fromDate: data, toDate: data });
    });
  }

}
export class DateFilterModel {
  public startDate: Date;
  public endDate: Date;
  constructor(startDate: Date, endDate: Date) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}
